// Styles
import 'snippets/card/card';
import './_main-blog.scss';